import { Falcon } from '@pocketlaw/tetris/macro';
const progressIconMap = {
    critical: <Falcon icon="exclamation-circle"/>,
    notable: <Falcon icon="eye"/>,
    minor: <Falcon icon="pen"/>,
    approved: <Falcon icon="check-circle"/>,
};
export const getIcon = (type) => progressIconMap[type];
